// @flow

import type { Action } from '../types/actions/unsavedwork'

export const ADD_UNSAVED_WORK = 'ADD_UNSAVED_WORK'
export const MARK_WORK_SAVED = 'MARK_WORK_SAVED'
export const CLEAR_UNSAVED_WORK = 'CLEAR_UNSAVED_WORK'

export function addUnsavedWork(
  workId: string,
  safePath: ?string,
  isInModal: ?boolean
): Object {
  return {
    type: ADD_UNSAVED_WORK,
    payload: {
      id: workId,
      safePath: safePath ?? null,
      modal: isInModal ?? false
    }
  }
}

export function markWorkSaved(workId: string): Object {
  return {
    type: MARK_WORK_SAVED,
    payload: {
      id: workId
    }
  }
}

export function clearUnsavedWork(): Object {
  return {
    type: CLEAR_UNSAVED_WORK
  }
}
